<ng-container *ngIf="item">
  <div class="list-block mb-4">
    <div class="list-block-header w-100">
      <button mat-mini-fab color="accent" class="color-white d-inline-block">{{ item.number }}</button>
      <h3 class="p-relative px-3">{{ item.title }}</h3>
    </div>
    <p class="p-2 px-5 mx-4 p-relative" [innerHtml]="item.content"></p>
  </div>
</ng-container>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/syllabuses/syllabus-numbering-list/syllabus-curriculum-numbering-list.component.html